import request from '@/utils/request'

// 获取合同列表
export function getContractList(data) {
  return request({
    url: '/move/getContractsList',
    method: 'post',
    data
  })
}

// 获取合同详情
export function getContractDetail(id) {
  return request({
    url: `/contract/${id}`,
    method: 'get'
  })
}

// 创建合同
export function createContract(data) {
  return request({
    url: '/move/addContracts',
    method: 'post',
    data
  })
}

// 更新合同
export function updateContract(data) {
  return request({
    url: `/move/editContracts`,
    method: 'post',
    data
  })
}

// 删除合同
export function deleteContract(params) {
  return request({
    url: `/move/delContracts`,
    method: 'delete',
    params
  })
}

// 提交合同审核
export function submitContract(id) {
  return request({
    url: `/contract/${id}/submit`,
    method: 'post'
  })
}

// 审核合同
export function approveContract(id, data) {
  return request({
    url: `/contract/${id}/approve`,
    method: 'post',
    data
  })
}

// 获取合同审批流程
export function getContractProcess(id) {
  return request({
    url: `/contract/${id}/process`,
    method: 'get'
  })
}

// 搜索客户
export function searchCustomers(query) {
  return request({
    url: '/move/getCusInfo',
    method: 'get',
    params: query 
  })
} 


export function getOpportunityContracts(query) {
  return request({
    url: '/move/getBusinessContract',
    method: 'get',
    params: query 
  })
} 
export function withdrawContract(){
	
}